"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPaymentQueueLineNegativeInventorySale = exports.isPaymentLineNegativeInventorySale = void 0;
const isPaymentLineBatchTrackedNotAssignedNegativeInventorySale = (inventorySubtracted, batches) => {
    const totalBatchQuantity = batches.reduce((total, batch) => total + batch.quantityRemaining, 0);
    return inventorySubtracted > totalBatchQuantity;
};
const isPaymentLineBatchTrackedNegativeInventorySale = (batchId, inventorySubtracted, batches) => {
    if (!batchId) {
        return isPaymentLineBatchTrackedNotAssignedNegativeInventorySale(inventorySubtracted, batches);
    }
    const productBatch = batches.find((batch) => batch.id === batchId);
    if (!productBatch) {
        return isPaymentLineBatchTrackedNotAssignedNegativeInventorySale(inventorySubtracted, batches);
    }
    return inventorySubtracted > productBatch.quantityRemaining;
};
const isPaymentLineNegativeInventorySale = ({ trackInventory, inventorySubtracted, quantity, batchId, isBatchTracked, batches, }) => {
    if (!trackInventory) {
        return false;
    }
    if (isBatchTracked) {
        return isPaymentLineBatchTrackedNegativeInventorySale(batchId, inventorySubtracted, batches);
    }
    return inventorySubtracted > quantity;
};
exports.isPaymentLineNegativeInventorySale = isPaymentLineNegativeInventorySale;
const isPaymentQueueLineNegativeInventorySale = (paymentQueueLine, posListing) => {
    if (!paymentQueueLine.productId) {
        return false;
    }
    if (!posListing.trackInventory) {
        return false;
    }
    if (posListing.isBatchTracked) {
        const totalBatchQuantity = posListing.batches.reduce((total, batch) => total + batch.quantityRemaining, 0);
        return paymentQueueLine.quantity > totalBatchQuantity;
    }
    return paymentQueueLine.quantity > posListing.quantity;
};
exports.isPaymentQueueLineNegativeInventorySale = isPaymentQueueLineNegativeInventorySale;
//# sourceMappingURL=negativeInventorySale.js.map